import appEvents from 'constants/appEvents.constant';
import trainEvents from '../config/train-events';
import appCONST from 'constants/app.constants';

export default function TrainsFiltersBaseController(
    $scope,
    $window,
    $rootScope,
    trainsFactory,
    $state,
    deviceDetector,
    timeService
) {
    'ngInject';

    let defaultFilter = false;

        $scope.labels = trainsFactory.getLabels();

        const comparisonFilter = {
            current: null,
            prev: null,
        };

        const flights = trainsFactory.getFlights();

        $scope.showFilters = true;

        if (_.isEmpty(flights)) {
            return $state.go('main.' + trainsFactory.getModule() + '.roundtrip');
        }

        //Show price by default only in desktop
        if (deviceDetector.isDesktop()) {
            $scope.showPrice = true;
            $scope.showStops = true;
        }

        $scope.DirectFlightsOnly = trainsFactory.params.DirectFlightsOnly;
        $scope.filters = flights.Filters;

        $scope.airlines = sortAirlines($scope.filters.Airline);

        //Show only one option for direct flights ( Value = 1)
        if ($scope.DirectFlightsOnly) {
            $scope.filters.QuantityOfStops = [_.find(flights.Filters.QuantityOfStops, {Value: 1})];
        }

        trainsFactory.params.Filters.MinimumPrice = flights.Filters.MinimumPrice;
        trainsFactory.params.Filters.MaximumPrice = flights.Filters.MaximumPrice;
        $scope.updateFilters = angular.copy(trainsFactory.params.Filters);

        $scope.priceRangeSlider = initRangeSlider($scope.filters.MinimumPrice, $scope.filters.MaximumPrice);

        $scope.toggleControl = toggleControl;

        $scope.convertedStop = initRangeSlider(
            timeService.convertTimeToMilliseconds($scope.filters.MinimumStopover),
            timeService.convertTimeToMilliseconds($scope.filters.MaximumStopover)
        );

        $scope.convertedDuration = initRangeSlider(
            timeService.convertTimeToMilliseconds($scope.filters.MinimumDuration),
            timeService.convertTimeToMilliseconds($scope.filters.MaximumDuration)
        );

        $scope.$on(trainEvents.COMPARISON_FILTER, applyComparisonFilter);

        $scope.$on(trainEvents.CLEAR_FILTERS, clearFilters);

        $scope.$on(trainEvents.TRIGGER_FLIGHT_FILTERS, toggleFilters);

        $scope.$watch('updateFilters',
            _.debounce(updateFiltersCallback, defaultFilter ? 100 : appCONST.filtersTimeout),
            true);

        $scope.ticketValidityFiltersExists = ticketValidityFiltersExists;
        $scope.changableFiltersExists = changableFiltersExists;
        $scope.refundableFiltersExists = refundableFiltersExists;
        $scope.baggageFiltersExists = baggageFiltersExists;
        $scope.benefitFiltersExists = benefitFiltersExists;

        $scope.isDepartureTimesAvailable = false;
        $scope.isArrivalTimesAvailable = false;

        angular.forEach(flights.Filters.RecommendationSegmentsTimes, function(segment) {
            segment.isDepartureTimesAvailable = !!segment.DepartureTimes.length;
            segment.isArrivalTimesAvailable = !!segment.ArrivalTimes.length;

            $scope.isDepartureTimesAvailable = $scope.isDepartureTimesAvailable || segment.isDepartureTimesAvailable;
            $scope.isArrivalTimesAvailable = $scope.isArrivalTimesAvailable || segment.isArrivalTimesAvailable;
        });

        function initRangeSlider(min, max) {
            return {
                model: min,
                range: max,
                floor: min,
                ceiling: max,
            };
        }

        function clearSlider() {
            if ($scope.priceRangeSlider.model !== $scope.filters.MinimumPrice
                || $scope.priceRangeSlider.range !== $scope.filters.MaximumPrice) {
                $scope.priceRangeSlider = {};
                $scope.priceRangeSlider = initRangeSlider(
                    $scope.filters.MinimumPrice,
                    $scope.filters.MaximumPrice
                );
            }
        }

        function clearCustomFilters() {
            trainsFactory.resetSegmentFilterData();
            //Price
            clearSlider();

            //Time
            $scope.convertedStop = {};
            $scope.convertedStop = initRangeSlider(
                timeService.convertTimeToMilliseconds($scope.filters.MinimumStopover),
                timeService.convertTimeToMilliseconds($scope.filters.MaximumStopover)
            );
            //Duration
            $scope.convertedDuration = {};
            $scope.convertedDuration = initRangeSlider(
                timeService.convertTimeToMilliseconds($scope.filters.MinimumDuration),
                timeService.convertTimeToMilliseconds($scope.filters.MaximumDuration)
            );
        }

        //return 2 ('Stop' value) if we hove only this option in QuantityOfStops filter
        function getQuantityOfStops() {
            let result;
            if ($scope.filters.QuantityOfStops.length === 1) {
                result = $scope.filters.QuantityOfStops[0].Value;
            } else {
                result = 3;
            }
            return result;
        }

        function isSegmentFilterApplied() {
            const stringify = angular.toJson;

            return trainsFactory.segmentFilterLength()
                && stringify(trainsFactory.params.Filters) === stringify({QuantityOfStops: 3})
                && stringify($scope.updateFilters) === stringify({QuantityOfStops: getQuantityOfStops()});
        }

        function updateFiltersHandler() {
            const filters = angular.copy($scope.updateFilters);
            let comparison = null;
            const segmentsTimesArray = [];
            if (filters.RecommendationSegmentsTimes) {
                _.forEach(filters.RecommendationSegmentsTimes, function(value, index) {
                    segmentsTimesArray[index] = value;
                });
                filters.RecommendationSegmentsTimes = segmentsTimesArray;
            }

            if (comparisonFilter.current) {
                comparison = comparisonFilter.prev = comparisonFilter.current;
                comparisonFilter.current = null;
            }

            const update = _.forEach(filters, function(value, key) {
                if (_.isArray(value) && _.isObject(value[0])) {
                    const cleaned = [];

                    _.forEach(value, function(subValue, subKey) {
                        const filterValue = _.pick(subValue, function(element) {
                            return element && element.length !== 0;
                        });

                        if (_.isObject(filterValue) && _.isEmpty(filterValue)) {
                            return;
                        }

                        cleaned[subKey] = filterValue;
                    });

                    filters[key] = cleaned;
                }
            });

            // TODO: to refactor
            const finalFilters = _.pick(update, function(value) {
                return value && value.length !== 0;
            });

            $rootScope.$broadcast(trainEvents.APPLY_FILTERS);
            trainsFactory.applyFilters(finalFilters, comparison);
            $window.scrollTo(0, 0);
        }

        function clearFilters() {
            comparisonFilter.prev = null;
            defaultFilter = true;
            // we check if we apply only segment filter and it not triggers update filter object
            if (isSegmentFilterApplied()) {
                trainsFactory.resetSegmentFilterData();
                updateFiltersHandler();
                return;
            }

            $scope.updateFilters = trainsFactory.params.Filters;
            trainsFactory.params.Filters.QuantityOfStops = getQuantityOfStops();
            clearCustomFilters();
        }

        function applyComparisonFilter(event, filters, comparison) {
            defaultFilter = true;
            if (comparisonFilter.prev === comparison) {
                return;
            }
            comparisonFilter.current = comparison;

            const tempFilters = {
                QuantityOfStops: getQuantityOfStops(),
                Airline: [filters.Airline[0]],
                MinimumPrice: $scope.updateFilters.MinimumPrice,
                MaximumPrice: $scope.updateFilters.MaximumPrice,
            };

            if (_.isEqual($scope.updateFilters, tempFilters)
                && (comparisonFilter.prev !== comparisonFilter.current)
            ) {
                updateFiltersHandler();
            } else {
                $scope.updateFilters = tempFilters;
            }
            clearCustomFilters();
        }

        function updateFiltersCallback(newValue, oldValue) {
            if (newValue !== oldValue) {

                /**
                 * If we apply any filter except 'clear all' we broadcast event
                 */
                if (defaultFilter === true) {
                    defaultFilter = false;
                }
                updateFiltersHandler();
            }
        }

        function toggleControl(param) {
            $scope.$broadcast(appEvents.REFRESH_SLIDER);
            $scope[param] = !$scope[param];
        }

        function toggleFilters() {
            $scope.showFilters = !$scope.showFilters;
        }

        function sortAirlines(airlines) {
            let keys = Object.keys(airlines);
            const result = [];
            keys = keys.sort(function(first, last) {
                return (first.toLowerCase() > last.toLowerCase() ? 1 : -1);
            });
            keys.forEach(function(item) {
                result.push({
                    name: item,
                    code: airlines[item],
                });
            });

            return result;
        }

        function benefitFiltersExists() {
            return baggageFiltersExists()
                || ticketValidityFiltersExists()
                || changableFiltersExists()
                || refundableFiltersExists();
        }

        function baggageFiltersExists() {
            return $scope.filters.BaggageAllowance.length > 1;
        }

        function refundableFiltersExists() {
            return $scope.filters.Refundable.length > 1;
        }

        function changableFiltersExists() {
            return $scope.filters.Changeable.length > 1;
        }

        function ticketValidityFiltersExists() {
            return $scope.filters.TicketValidity.length;
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-filters-base-controller.js